import styled, { css, StyledComponentProps } from 'styled-components';

import { typographyStyles, TypographyStylesProps } from './typographyStyles';

type BodyVariant = 1 | 2 | 3 | 4 | 5;
type BodyStyle = {
  fontSize: string;
  lineHeight: string;
};

type Bodies = { [key in BodyVariant]: BodyStyle };

export const bodies = (medium: boolean): Bodies => ({
  1: {
    fontSize: '22px',
    lineHeight: '40px',
  },
  2: {
    fontSize: '20px',
    lineHeight: '36px',
  },
  3: {
    fontSize: '18px',
    lineHeight: medium ? '24px' : '32px',
  },
  4: {
    fontSize: '16px',
    lineHeight: medium ? '24px' : '28px',
  },
  5: {
    fontSize: '14px',
    lineHeight: '24px',
  },
});

export interface BodyStylesProps extends TypographyStylesProps {
  variant: BodyVariant;
  medium?: boolean;
}

export interface BodyProps
  extends StyledComponentProps<
    'div',
    Record<string, any>,
    TypographyStylesProps & BodyStylesProps,
    never
  > {}

export const bodyStyles = css<BodyStylesProps>`
  font-family: 'Manrope';
  font-size: ${({ variant = 3, medium = false }) =>
    bodies(medium)[variant].fontSize};
  line-height: ${({ variant = 3, medium = false }) =>
    bodies(medium)[variant].lineHeight};
  font-weight: ${({ medium = false }) => (medium ? '500' : '400')};
  ${typographyStyles}
`;

export const Body = styled.p<BodyProps>`
  display: block;
  ${bodyStyles}
`;
